import sesion from './Sesion';
import menuProductos from './MenuProductos';
import menuCategorias from './MenuCategorias';
import cambioContrasena from './CambioContrasena';
import invocadorReportes from './InvocadorReportes';
import tarjetas from '../../../Productos/Tarjetas/App/store/Reducers/Tarjetas';
import atlas from '../../../Productos/Atlas/App/store/Reducers/Atlas';
import { reducer as idle } from '../../Screens/TimerInactividad/components/TimerInactividad';

export default {
    sesion,
    menuProductos,
    menuCategorias,
    cambioContrasena,
    invocadorReportes,
    idle,
    tarjetas,
    atlas
};


// WEBPACK FOOTER //
// ./Portico/App/store/Reducers/index.js